module.exports = __webpack_public_path__ + "images/emoji/whale.55304bddd88e8512d22a.png";